














































































/* eslint-disable */
import { Component, Vue, Watch } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import axios from "axios";
import { Token } from "../utils/Token";

@Component({
  components: {},
})
export default class ChangePassword extends Vue {
  private oldPassword = "";
  private newPassword = "";
  private confirmPassword = "";

  private hideOldPassword = true;
  private hideNewPassword = true;
  private hideConfirmPassword = true;

  private oldPasswordRules: any = [];
  private newPasswordRules: any = [];
  private confirmPasswordRules: any = [];

  private errorModalFlag = false;
  private errorText = "";
  private errorTitle = "";

  //  don't allow entrance to app if no token exists
  /* beforeCreate() {
    const token = localStorage.getItem("token");

    if (!token) {
      this.$router.push({ name: "Login" });
    }
  } */

  created() {
    EventBus.$on("closeErrorModal", (value: boolean) => {
      this.errorModalFlag = value;
    });
  }

   beforeDestroy () {
    EventBus.$off('closeErrorModal')
   }

  @Watch("oldPassword")
  firstNameChanged() {
    this.oldPasswordRules = [];
  }

  @Watch("newPassword")
  lastNameChanged() {
    this.newPasswordRules = [];
  }

  @Watch("confirmPassword")
  extensionChanged() {
    this.confirmPasswordRules = [];
  }

  private async submitHandler(): Promise<void> {
    this.oldPasswordRules = [(v: any) => !!v || "Password is required"];

    this.newPasswordRules = [
      (v: any) => !!v || "Password is required",
      (v: any) =>
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{6,}$/.test(v) ||
        "Must contain one capital case, one lower case, one digit and be more that 6 characters",
    ];

    this.confirmPasswordRules = [
      (v: any) => !!v || "Password is required",
      (v: any) => v === this.newPassword || "Must match new password",
    ];

    const self = this;
    const token = await Token.getTokenWithExpiry("token");
    setTimeout(function () {
      // In order for TypeScript to know which type is being used for form, we need to cast the value.
      const result = (
        self.$refs.form as Vue & {
          validate: () => boolean;
        }
      ).validate();
      console.log("result of validation:", result);
      const data = { password: self.newPassword };
      if (result) {
        ////EventBus.$emit("BeginLoader",null );   

        // successful validation -> execute API call
        axios({
          method: "post",
          url: `${process.env.VUE_APP_BASE_URL}/user/changePassword`,
          withCredentials: true,
          data: data,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            ////EventBus.$emit("FinishLoader",null );
            if (response.data.code == 401) {
              EventBus.$emit("LogOutEventBus", false);
            } else {
              console.log("successful change password API response:", response);
              console.log("with code:", response.data.code);

              if (response.data.code == 200) {
                //success
                console.log("successful change");
                self.$router.push({ name: "DeviceListing" });
              } else {
                //fail
                console.log("500 response code");
                self.errorText = "There was an error in changing the password.";
                self.errorModalFlag = true;
              }
            }
          })
          .catch((err) => {
            ////EventBus.$emit("FinishLoader",null );
            console.log("failed API call:", err);
            self.errorText = "There was an error in changing the password.";
            self.errorModalFlag = true;
          });
      }
    });
  }

  private navigateBack() {
    const token = localStorage.getItem("token");
    if (!token) {
                console.log("getTokenWithExpiry returns null when Generate new Token");
                return null;
    }
    const atype = JSON.parse(token).type;
    if(atype!=0){
      this.$router.push({ name: "Files" });
    }else{
      this.$router.push({ name: "DeviceListing" });
    }
  }
}
